import classNames from 'classnames';
import styles from './TrackingPixel.module.css';

//#region [Props]
type AdProps = {
	targetId: string;
	className?: string;
};
//#endregion

//#region [Component]
export default function TrackingPixel({ targetId, className }: AdProps) {
	return <div id={targetId} className={classNames(styles.STrackingPixel, className)}></div>;
}
//#endregion